import Vue from 'vue'
import { createConsent } from '~/utils/cookie-consent'
import { createGoogleAnalytics } from '~/utils/google-analytics'

export default function ({ app, $config }, inject) {
  const consent = createConsent(process.client ? document : null)
  Vue.observable(consent.state)
  inject('consent', consent)
  if (!process.client) return

  const google = createGoogleAnalytics({
    win: window, doc: document, router: app.router,
    id: $config.googleAnalyticsId,
    tagId: $config.googleTagId,
    enabled: process.env.NODE_ENV === 'production' && ['jaty.pl', 'www.jaty.pl'].includes(window.location.hostname),
    allowed: () => consent.sync()
  })
  let expiryTimer
  let routerReady = false
  function scheduleExpiry () {
    clearTimeout(expiryTimer)
    const remaining = consent.expiresIn()
    if (remaining !== null) expiryTimer = setTimeout(() => { consent.sync(); scheduleExpiry() }, Math.min(remaining + 1, 2147483647))
  }
  const capture = route => {
    if (!app.$auth || !app.$auth.loggedIn) consent.capture(route, app.router)
  }
  consent.subscribe(granted => {
    if (routerReady) {
      google.update(granted)
      if (granted) capture(app.router.currentRoute)
    }
    scheduleExpiry()
  })
  consent.cleanup(false)
  consent.sync()
  app.router.onReady(() => {
    routerReady = true
    capture(app.router.currentRoute)
    google.update(consent.state.analytics)
  })
  app.router.afterEach(to => { if (routerReady) { capture(to); google.view(to) } })
  const synchronize = () => { consent.sync(); scheduleExpiry() }
  window.addEventListener('focus', synchronize)
  window.addEventListener('pageshow', synchronize)
  window.addEventListener('storage', synchronize)
  document.addEventListener('visibilitychange', synchronize)
  scheduleExpiry()
}
